module.exports = __webpack_public_path__ + "img/bg.3bbb8c17.png";